module.exports = "https://cdn.hellotech.com/client-assets/doorbell_wide_8aff8cd3b1a269d8d7933a78f6229d78.jpg";